import Vue from 'vue'
import Router from 'vue-router'

import Index from '@/components/Index'
import AboutUs from '@/components/AboutUs'
import WyneBassadors from '@/components/WyneBassadors'
import WyneMaker from '@/components/WyneMaker'
import WyneCellar from '@/components/WyneCellar'

import Atlas from '@/views/Atlas'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/AboutUs',
            name: 'AboutUs',
            component: AboutUs
        },
        {
            path: '/WyneBassadors',
            name: 'WyneBassadors',
            component: WyneBassadors
        },
        {
            path: '/admin_wynemaker',
            name: 'WyneMaker',
            component: WyneMaker
        },
        {
            path: '/admin_wynecellar',
            name: 'WyneCellar',
            component: WyneCellar
        },
        {
            path: '/atlas',
            name: 'Atlas',
            component: Atlas
        },
    ],
    mode: 'history'
})